import React,{useState,useEffect} from 'react';
import './styles/App.css';
import Calendar from 'react-calendar';
import TopTitle from './TopTitle';
import { Container } from 'react-bootstrap';
import { formatDate,instance } from './common';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';



function minusArrow(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 <= 10 && text.split('-')[1]*1 > 1){
            text = text.split('-')[0] + '-0' + ((text.split('-')[1]*1)-1);
        }else if(text.split('-')[1]*1 > 10 && text.split('-')[1]*1 < 13){
            text = text.split('-')[0] + '-' + ((text.split('-')[1]*1)-1);
        }else if(text.split('-')[1]*1 == 1){
            text = (text.split('-')[0]*1-1) + '-12';
        }
    }
    return text;
    
}

function minusArrowD(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 <= 10 && text.split('-')[1]*1 > 1){
            text = (text.split('-')[0]*1-1) + '-0' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 > 10 && text.split('-')[1]*1 < 13){
            text = (text.split('-')[0]*1-1) + '-' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 == 1){
            text = (text.split('-')[0]*1-1) + '-' + ((text.split('-')[1]*1));
        }
    }
    return text;
    
}


function plusArrow(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 < 9 && text.split('-')[1]*1 >= 1){
            text = text.split('-')[0] + '-0' + ((text.split('-')[1]*1)+1);
        }else if(text.split('-')[1]*1 >= 9 && text.split('-')[1]*1 < 12){
            text = text.split('-')[0] + '-' + ((text.split('-')[1]*1)+1);
        }else if(text.split('-')[1]*1 == 12){
            text = (text.split('-')[0]*1+1) + '-01';
        }
    }
    return text;
    
}

function plusArrowD(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 < 10 && text.split('-')[1]*1 >= 1){
            text = (text.split('-')[0]*1+1) + '-0' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 >= 10 && text.split('-')[1]*1 < 12){
            console.log('변환 전 : ', text)
            text = (text.split('-')[0]*1+1) + '-' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 == 12){
            text = (text.split('-')[0]*1+1) + '-' + ((text.split('-')[1]*1));
        }
    }
    return text;
    
}



function dayDisabled(data,date){
    let isCheck = false;
    data.forEach(v => {
        if(v.h_date === formatDate(date)) isCheck = true
    })
    console.log('isCheck : ', isCheck)
    return isCheck
}



function CapitalCalendar({history, location, match}) {

    const session = JSON.parse(window.sessionStorage.result);
    const {u_type,u_id} = session;


    const query = queryString.parse(location.search);
    const si_id = query.si_id;

    const [value, onChange] = useState(new Date());

    const goBack = () => {
        history.goBack();
    };

    const marginstyle = {
        marginBottom:"50px",
        marginTop:"70px"
    }
    
    const calcBtn = {
        width: "100%",
        padding: "10px",
        borderRadius: "5px"
    }
    const [data, setData] = useState([]);
    const [disabled, setDisabled] = useState([]);
    const [show_date, setDate] = useState(formatDate(value).slice(0,7));
    let obj = {u_id:u_id}

    const ppp = 10;
    const [page, setPage] = useState(1);

    let disObj = {
        page: page,
        ppp: ppp,
        h_si_id: si_id,
        show_date:show_date
    }
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/holiday/all', disObj).then(function (res) {
                setDisabled(res.data.rows);
            });

            instance.post('/cart/checked',obj).then(function(res){

                setData(res.data.rows);
          
            
            });
 
        };

        fetchData();

        let prev = document.querySelector('.react-calendar__navigation__prev-button');
        prev.addEventListener("click", () => setDate(minusArrow), false);

        let next = document.querySelector('.react-calendar__navigation__next-button');
        next.addEventListener("click", () => setDate(plusArrow), false);

        let prevD = document.querySelector('.react-calendar__navigation__prev2-button');
        prevD.addEventListener("click", () => setDate(minusArrowD), false);

        let nextD = document.querySelector('.react-calendar__navigation__next2-button');
        nextD.addEventListener("click", () => setDate(plusArrowD), false);


    }, [show_date]);

    const tileDisabled =  ({activeStartDate, date, view }) => dayDisabled(disabled,date) === true;

    const onClickYear = (value) => {
        setDate(formatDate(value).slice(0,7))
    }

    const onClickMonth = (value) => {
        setDate(formatDate(value).slice(0,7))
    }

    const onClick = () => {

        let test = {
            r_gubun:'',
            r_status:'예약완료',
            si_id:si_id,
            ag_id:u_id,
            r_reserve_date:formatDate(value),
            s_id:JSON.stringify(data),
        }

        const fetchData = async () => {
            instance.post('/users/push_first',{u_sigong:si_id}).then(function(res){
                console.log('res : ', res)
            });

            instance.post('/cart/chk-delete',{u_id:u_id}).then(function(res){
                instance.post('/reserve/insert',{obj:test}).then(function(res){
                    console.log('res : ', res.data.insertId)
                    history.push('/reserve_detail?r_id='+res.data.insertId+'&date='+formatDate(value)+'&si_id='+si_id);
                });
            
            });
            
        };

        fetchData();

       
    }

    console.log('data : ', data)
    
  return (
    <>
    <Container>
        <TopTitle title="예약일 선택"/>
        <Calendar className="c_mgauto" onChange={onChange}  value={value} tileDisabled={tileDisabled}/>
        <div>
            <span className="btn btn-primary" style={calcBtn} onClick={onClick}>접수하기</span>
        </div>
        <div>
            <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
        </div>  
    </Container>
    </>
  );
}

export default CapitalCalendar;